<span
  class="confirm-popover-origin"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  (click)="open()"
>
  <ng-content></ng-content>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="overlayPanelClass"
  [cdkConnectedOverlayPush]="true"
  (positionChange)="onPositionChange($event)"
  (overlayOutsideClick)="close()"
  (detach)="close()"
>
  <div class="confirm-popover" [ngClass]="arrowClass">
    <span class="confirm-popover__message">{{ message }}</span>
    <div class="confirm-popover__actions">
      <button
        type="button"
        class="confirm-popover__btn confirm-popover__btn--confirm"
        [class.confirm-popover__btn--danger]="variant === 'danger'"
        (click)="onConfirm()"
      >
        {{ confirmLabel }}
      </button>
      <button
        type="button"
        class="confirm-popover__btn"
        (click)="onCancel()"
      >
        {{ cancelLabel }}
      </button>
    </div>
  </div>
</ng-template>
